import $ from 'jquery';
import { phonePrefixDefault } from '../common/constants';

export function scrollTopOfForm() {
  let whereToScroll = $('#content').offset().top;
  $('html').animate({scrollTop:whereToScroll}, 'slow'); //IE, FF
  $('body').animate({scrollTop:whereToScroll}, 'slow'); //chrome, don't know if Safari works
}

export function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

export function isFocusedInput(nameInput, whereToFind = 'name') {
  if (!process.env.IS_BROWSER) {
    return false;
  }
  // console.log('fokusly je: ',document.activeElement);
  if(!document.activeElement) {
    // console.log('dokument neni');
    return false;
  }
  return document.activeElement[whereToFind] === nameInput;
}

var re = {
    not_string: /[^s]/,
    not_bool: /[^t]/,
    not_type: /[^T]/,
    not_primitive: /[^v]/,
    number: /[diefg]/,
    numeric_arg: /bcdiefguxX/,
    json: /[j]/,
    not_json: /[^j]/,
    text: /^[^\x25]+/,
    modulo: /^\x25{2}/,
    placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
    key: /^([a-z_][a-z_\d]*)/i,
    key_access: /^\.([a-z_][a-z_\d]*)/i,
    index_access: /^\[(\d+)\]/,
    sign: /^[+-]/
}

function sprintf() {
    var key = arguments[0], cache = sprintf.cache
    if (!(cache[key] && cache.hasOwnProperty(key))) {
        cache[key] = sprintf.parse(key)
    }
    return sprintf.format.call(null, cache[key], arguments)
}

sprintf.format = function(parse_tree, argv) {
    var cursor = 1, tree_length = parse_tree.length, node_type = '', arg, output = [], i, k, match, pad, pad_character, pad_length, is_positive = true, sign = ''
    for (i = 0; i < tree_length; i++) {
        node_type = get_type(parse_tree[i])
        if (node_type === 'string') {
            output[output.length] = parse_tree[i]
        }
        else if (node_type === 'array') {
            match = parse_tree[i] // convenience purposes only
            if (match[2]) { // keyword argument
                arg = argv[cursor]
                for (k = 0; k < match[2].length; k++) {
                    if (!arg.hasOwnProperty(match[2][k])) {
                        throw new Error(sprintf('[sprintf] property "%s" does not exist', match[2][k]))
                    }
                    arg = arg[match[2][k]]
                }
            }
            else if (match[1]) { // positional argument (explicit)
                arg = argv[match[1]]
            }
            else { // positional argument (implicit)
                arg = argv[cursor++]
            }

            if (re.not_type.test(match[8]) && re.not_primitive.test(match[8]) && get_type(arg) === 'function') {
                arg = arg()
            }

            if (re.numeric_arg.test(match[8]) && (get_type(arg) !== 'number' && isNaN(arg))) {
                throw new TypeError(sprintf("[sprintf] expecting number but found %s", get_type(arg)))
            }

            if (re.number.test(match[8])) {
                is_positive = arg >= 0
            }

            switch (match[8]) {
                case 'b':
                    arg = parseInt(arg, 10).toString(2)
                break
                case 'c':
                    arg = String.fromCharCode(parseInt(arg, 10))
                break
                case 'd':
                case 'i':
                    arg = parseInt(arg, 10)
                break
                case 'j':
                    arg = JSON.stringify(arg, null, match[6] ? parseInt(match[6], 10) : 0)
                break
                case 'e':
                    arg = match[7] ? parseFloat(arg).toExponential(match[7]) : parseFloat(arg).toExponential()
                break
                case 'f':
                    arg = match[7] ? parseFloat(arg).toFixed(match[7]) : parseFloat(arg)
                break
                case 'g':
                    arg = match[7] ? parseFloat(arg).toPrecision(match[7]) : parseFloat(arg)
                break
                case 'o':
                    arg = arg.toString(8)
                break
                case 's':
                    arg = String(arg)
                    arg = (match[7] ? arg.substring(0, match[7]) : arg)
                break
                case 't':
                    arg = String(!!arg)
                    arg = (match[7] ? arg.substring(0, match[7]) : arg)
                break
                case 'T':
                    arg = get_type(arg)
                    arg = (match[7] ? arg.substring(0, match[7]) : arg)
                break
                case 'u':
                    arg = parseInt(arg, 10) >>> 0
                break
                case 'v':
                    arg = arg.valueOf()
                    arg = (match[7] ? arg.substring(0, match[7]) : arg)
                break
                case 'x':
                    arg = parseInt(arg, 10).toString(16)
                break
                case 'X':
                    arg = parseInt(arg, 10).toString(16).toUpperCase()
                break
                default:
            }
            if (re.json.test(match[8])) {
                output[output.length] = arg
            }
            else {
                if (re.number.test(match[8]) && (!is_positive || match[3])) {
                    sign = is_positive ? '+' : '-'
                    arg = arg.toString().replace(re.sign, '')
                }
                else {
                    sign = ''
                }
                pad_character = match[4] ? match[4] === '0' ? '0' : match[4].charAt(1) : ' '
                pad_length = match[6] - (sign + arg).length
                pad = match[6] ? (pad_length > 0 ? str_repeat(pad_character, pad_length) : '') : ''
                output[output.length] = match[5] ? sign + arg + pad : (pad_character === '0' ? sign + pad + arg : pad + sign + arg)
            }
        }
    }
    return output.join('')
}

sprintf.cache = {}

sprintf.parse = function(fmt) {
    var _fmt = fmt, match = [], parse_tree = [], arg_names = 0
    while (_fmt) {
        if ((match = re.text.exec(_fmt)) !== null) {
            parse_tree[parse_tree.length] = match[0]
        }
        else if ((match = re.modulo.exec(_fmt)) !== null) {
            parse_tree[parse_tree.length] = '%'
        }
        else if ((match = re.placeholder.exec(_fmt)) !== null) {
            if (match[2]) {
                arg_names |= 1
                var field_list = [], replacement_field = match[2], field_match = []
                if ((field_match = re.key.exec(replacement_field)) !== null) {
                    field_list[field_list.length] = field_match[1]
                    while ((replacement_field = replacement_field.substring(field_match[0].length)) !== '') {
                        if ((field_match = re.key_access.exec(replacement_field)) !== null) {
                            field_list[field_list.length] = field_match[1]
                        }
                        else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
                            field_list[field_list.length] = field_match[1]
                        }
                        else {
                            throw new SyntaxError("[sprintf] failed to parse named argument key")
                        }
                    }
                }
                else {
                    throw new SyntaxError("[sprintf] failed to parse named argument key")
                }
                match[2] = field_list
            }
            else {
                arg_names |= 2
            }
            if (arg_names === 3) {
                throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported")
            }
            parse_tree[parse_tree.length] = match
        }
        else {
            throw new SyntaxError("[sprintf] unexpected placeholder")
        }
        _fmt = _fmt.substring(match[0].length)
    }
    return parse_tree
}

// eslint-disable-next-line
function vsprintf(fmt, argv, _argv) {
    _argv = (argv || []).slice(0)
    _argv.splice(0, 0, fmt)
    return sprintf.apply(null, _argv)
}

/**
 * helpers
 */
function get_type(variable) {
    if (typeof variable === 'number') {
        return 'number'
    }
    else if (typeof variable === 'string') {
        return 'string'
    }
    else {
        return Object.prototype.toString.call(variable).slice(8, -1).toLowerCase()
    }
}

var preformattedPadding = {
    '0': ['', '0', '00', '000', '0000', '00000', '000000', '0000000'],
    ' ': ['', ' ', '  ', '   ', '    ', '     ', '      ', '       '],
    '_': ['', '_', '__', '___', '____', '_____', '______', '_______'],
}
function str_repeat(input, multiplier) {
    if (multiplier >= 0 && multiplier <= 7 && preformattedPadding[input]) {
        return preformattedPadding[input][multiplier]
    }
    return Array(multiplier + 1).join(input)
}

//account prefix modulo 11 validation test

function validateAccountPrefix(Prefix) {
    const validate = (10 * Prefix[0] + 5 * Prefix[1] + 8 * Prefix[2] + 4 * Prefix[3] + 2 * Prefix[4] + 1 * Prefix[5]) % 11 === 0
    if (validate) {
        // console.log("Prefix validation passed!");
    }
    else {
        // console.log("Prefix validation failed");
    }
    return validate;
}

// account number modulo 11 validation test
// plus != 0 test
function validateAccoutNumber(AccountNumber) {
    const validate = (6 * AccountNumber[0]
        + 3 * AccountNumber[1]
        + 7 * AccountNumber[2]
        + 9 * AccountNumber[3]
        + 10 * AccountNumber[4]
        + 5 * AccountNumber[5]
        + 8 * AccountNumber[6]
        + 4 * AccountNumber[7]
        + 2 * AccountNumber[8]
        + 1 * AccountNumber[9])
        % 11 === 0 && (+AccountNumber);

    if (validate) {
        // console.log("Account number validation passed!");
    }
    else {
        // console.log("Account validation failed");
    }

    return validate;
}

// const bankAccount="-7770227/0100"

//bank account validation

// validateAccount(bankAccount);

export function validateAccount(data) {
    if (typeof data === 'string') {
        return validateCZAccount(data); // BC
    }

    if (data.k01_iban) {
        return validateIBANAccount(data.k01_iban);
    }

    return validateCZAccount(`${data.k01_prefix}-${data.k01_number}/${data.k10_bank_code}`);
}

/*
 * Returns 1 if the IBAN is valid 
 * Returns FALSE if the IBAN's length is not as should be (for CY the IBAN Should be 28 chars long starting with CY )
 * Returns any other number (checksum) when the IBAN is invalid (check digits do not match)
 */
function isValidIBANNumber(input) {
    var CODE_LENGTHS = {
        AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
        CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
        FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
        HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
        LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
        MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
        RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26
    };
    var iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
        code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/), // match and capture (1) the country code, (2) the check digits, and (3) the rest
        digits;
    // check syntax and length
    if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
        return false;
    }
    // rearrange country code and check digits, and convert chars to ints
    digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
        return letter.charCodeAt(0) - 55;
    });
    // final check
    return mod97(digits) === 1;
}
function mod97(string) {
    var checksum = string.slice(0, 2), fragment;
    for (var offset = 2; offset < string.length; offset += 7) {
        fragment = String(checksum) + string.substring(offset, offset + 7);
        checksum = parseInt(fragment, 10) % 97;
    }
    return checksum;
}

export function validateIBANAccount(ibanAccount) {
    return isValidIBANNumber(ibanAccount);
}

export function validateCZAccount(bankAccount) {
    //regular expression for whole account validation
    const regexp = new RegExp("^(([0-9]{0,6})-)?([0-9]{1,10})/([0-9]{4})$")
    //format validation
    const formatValidation = regexp.test(bankAccount)

    if (formatValidation) {
        // console.log("Format test passed!")
    }
    else {
        // console.log("Format test failed!")
    }
    //splitting account number

    let prefix = bankAccount.split("-")[0];
    if (prefix === '') {
        prefix = '000000'
    }
    const accountNumber = bankAccount.split("/")[0].split("-")[1];
    // const bankNumber = bankAccount.split("/")[1];
    //adding nulls to prefix
    const prefixWithNulls = sprintf('%06d', prefix);
    //modulo 11 test for prefix validation
    const prefixValidation = validateAccountPrefix(prefixWithNulls);
    //adding nulls to account number
    const accountNumberWithNulls = sprintf('%10d', accountNumber);
    //modulo 11 test for account number validation
    const accountValidation = validateAccoutNumber(accountNumberWithNulls);
    //final validation
    if (formatValidation && prefixValidation && accountValidation) {
        // console.log("Validation passed!")
        return true;
    }
    else {
        // console.log("Validation failed!")
        return false;
    }
}

function formatCZAccount(prefix, number, bankCode) {
    return `${prefix && prefix.length > 0 ? prefix + '-' : ''}${number}\u00a0/\u00a0${bankCode}`;
}

function formatIBANAccount(iban) {
    const raw = iban.replace(/[ ]+/g, '');
    return raw.match(/.{1,4}/g).join(' ');
}

export function formatAccount(data) {
    if (data.k01_iban) {
        return formatIBANAccount(data.k01_iban);
    }

    return formatCZAccount(data.k01_prefix, data.k01_number, data.k10_bank_code);
}

export function validateTelephoneNumber(telephone, necessaryFilledIn = false) {
  if((telephone === phonePrefixDefault || telephone.length === 0) && !necessaryFilledIn) return true;
  const reg = new RegExp("^(([-()/+–—*#0-9]{9,25}))$"); ///^[0-9]+$/i;
  const ret = reg.test(telephone); //telephone.lenght > 8 && telephone.lenght < 26 &&
  return ret;
}

/**
 * Returns null if validation is succesfull errorMessage otherwise
 * @param {*} val 
 * @param {*} min 
 * @param {*} max 
 * @param {*} errorMessage 
 */
export function validateNumber(val, min = null, max = null, errorMessage = true) {
    if(!/^[0-9]+([.,][0-9]+)?$/.test(val)) {
        return errorMessage;
    }

    if (min !== null && +val < min) {
        return errorMessage;
    }

    if (max !== null && +val > max) {
        return errorMessage;
    }

    return null;
}

export function mobileTabletcheck() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

export function recountPeopleOptions(aPeople) {
  // console.log('apeople: ', aPeople.toJS());
  return aPeople.toJS().map((oPerson, indexPerson)=>{
    return {
      label: oPerson.firstName + " " + oPerson.lastName,
      value: indexPerson,
    };
  }).concat({
    label: 'zadat nové',
    value: 'new',
  });
}

export function startStickyHeader() {
  /**
   * Bootstrap UI demo
   */

  $(function() {
    /**
     * Insert @ into blank email inputs on focus if empty.
     */
    $('input[type="email"]:not(.js-form-control)').focus(function() {
      var input = $(this);
      if (!input.val()) {
        input.val('@');
      }
    }).blur(function() {
      var input = $(this);
      if (input.val() === '@') {
        input.val('');
      }
    });

    /**
     * Animated Scrolling
     */
    $('.js-scroll').click(function() {
      if (window.location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && window.location.hostname === this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top
          }, 1000);
          return false;
        }
      }
    });

    /**
     * Sticky header
     */
    var scrollFrom = 0;
    var navigationEl = $('.js-header');
    var navbarEl = $('.navbar');

    function stickyHeaderShow() {
      navigationEl.removeClass('header-sticky-hidden');
      navigationEl.addClass('header-sticky header-sticked');
    }

    function stickyHeaderResize() {
      navbarEl.removeClass('navbar-sticky');
    }

    function stickyHeaderHide() {
      navigationEl.addClass('header-sticky-hidden');
      navigationEl.removeClass('header-sticky');
      navbarEl.addClass('navbar-sticky');
    }

    function stickyHeaderStop() {
      navigationEl.removeClass('header-sticky header-sticked');
      navbarEl.removeClass('navbar-sticky');
    }

    $(window).scroll(function() {
      var scrollTo = $(this).scrollTop();
      var nav = $('.js-header');
      var navHeight = parseInt(nav.outerHeight(), 0);
      var navCollapse = nav.find('.navbar-collapse');

      if (scrollTo > 1) {
        if ((scrollFrom - scrollTo) > 0) {
          stickyHeaderShow();
          if(scrollTo < navHeight) {
            stickyHeaderResize();
          }
        } else if((scrollFrom - scrollTo) < 0 && scrollTo > navHeight && !navCollapse.hasClass('in')) {
          stickyHeaderHide();
        }
      } else {
        stickyHeaderStop();
      }

      scrollFrom = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
    });

    // $('.navbar-nav a').click(function () {
    //   console.log('predcollapse: ', $('#navigation'));
    //   setTimeout(() =>$('#navigation').collapse('hide'),100);
    // });

    /**
     * Smart labels
     */
    $('.js-form-control').focus(function() {
      var input = $(this);
      var label = $(this).prev('label');
      if (!label.length) {
        label = $(this).parent().prev('label');
      }
      if (!input.val()) {
        label.addClass('active');
      }
    }).blur(function() {
      var input = $(this);
      var label = $(this).prev('label');
      if (!label.length) {
        label = $(this).parent().prev('label');
      }
      if (!input.val()) {
        label.removeClass('active');
      }
    }).change(function () {
      var input = $(this);
      var label = $(this).prev('label');
      if (!label.length) {
        label = $(this).parent().prev('label');
      }
      if (input.val()) {
        label.addClass('active');
      }
    });

  });
}
